module.exports = __webpack_public_path__ + "img/hontai_ExtreamRed.80ea8b18.png";